// removed by extract-text-webpack-plugin
module.exports = {"marketGroup":"sNVa9_Umk9t8YFcns8cn4","marketType":"_39tp8BIIlCDpBFDX-UPtN-","winningMarginTeamHeader":"_25SgjXQKzHSyQkyX-o8RF2","scoreGroup":"_30CpTm5FmtFjqxsOqbR2CM","marketText":"m7ZiCvOpc20Gkd0-jxh-A","oddsButton":"_3xq8FGf-hvdMKa4pfXzMHi","scoreGroup2ndLevel":"_2nSUxV95ui2OirqhxXaXqB"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/baseball/css/markets.css
// module id = 992
// module chunks = 0